/**
 * 弃用警告屏蔽器
 * 解决 DOMNodeInserted 等弃用警告问题
 */

// 需要屏蔽的弃用警告关键词
const suppressPatterns = [
  'DOMNodeInserted',
  'DOMNodeRemoved', 
  'DOMSubtreeModified',
  'DOMAttrModified',
  'DOMCharacterDataModified',
  'Listener added for a \'DOMNodeInserted\' mutation event',
  'Support for this event type has been removed',
  'chromestatus.com/feature/5083947249172480'
]

// 弃用的DOM事件类型
const deprecatedEvents = ['DOMNodeInserted', 'DOMNodeRemoved', 'DOMSubtreeModified', 'DOMAttrModified', 'DOMCharacterDataModified']

/**
 * 检查消息是否应该被屏蔽
 */
function shouldSuppress(message) {
  if (typeof message !== 'string') return false
  return suppressPatterns.some(pattern => 
    message.includes(pattern) || message.toLowerCase().includes(pattern.toLowerCase())
  )
}

/**
 * 初始化弃用警告屏蔽器
 */
export function initDeprecationSuppressor() {
  try {
    // 屏蔽控制台输出
    const originalWarn = console.warn
    const originalError = console.error
    
    console.warn = function(message, ...args) {
      if (shouldSuppress(message)) return
      originalWarn.call(console, message, ...args)
    }
    
    console.error = function(message, ...args) {
      if (shouldSuppress(message)) return
      originalError.call(console, message, ...args)
    }
    
    // 阻止弃用事件监听器
    const originalAddListener = Element.prototype.addEventListener
    Element.prototype.addEventListener = function(type, listener, options) {
      if (deprecatedEvents.includes(type)) return
      return originalAddListener.call(this, type, listener, options)
    }
    
    // 处理Document
    if (typeof Document !== 'undefined' && Document.prototype.addEventListener) {
      const originalDocListener = Document.prototype.addEventListener
      Document.prototype.addEventListener = function(type, listener, options) {
        if (deprecatedEvents.includes(type)) return
        return originalDocListener.call(this, type, listener, options)
      }
    }
    
    console.log('✅ 弃用警告屏蔽器已启用')
  } catch (error) {
    console.error('❌ 弃用警告屏蔽器失败:', error)
  }
}
